module.exports = __webpack_public_path__ + "static/media/Invite.e3673fc6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Invite.svg
// module id = 945
// module chunks = 0